<template>
    <div class="card">
        <div class="image-container">
            <div class="card-image">
                <component v-if="icon" :is="icon" style="color: white;" />
            </div>
        </div>
        <h2 class="card-title">{{ title }}</h2>
        <p class="card-content">{{ content }}</p>
    </div>
</template>

<script>
export default {
    name: "LandingCard",
    props: {
        title: {
            type: String,
            required: true
        },
        content: {
            type: String,
            default: ""
        },
        image: {
            type: String,
            default: null
        },
        icon: { type: Object, default: null }
    }
}
</script>


<style lang="scss" scoped>
.card {
    border-radius: 24px;
    padding: 10px;
    height: 276px;
    overflow: hidden;
    border: 1px solid #DCE3E7;
    background-image: url("../../assets/images/cardBg.png");
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 384px;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: 74px;
    height: 74px;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #DCE3E7;

    .card-image {
        background: linear-gradient(to bottom, #ED4E24, #F97316);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }
}

.card-body {
    padding: 16px;
}

.card-title {
    font-size: 20px;
    color: #000000;
    font-weight: 500;
    margin: 10px 0;
    font-family: "Open Runde", sans-serif;
}

.card-content {
    font-size: 14px;
    color: #555555;
    font-weight: 400;
    font-family: "Open Runde", sans-serif;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }
}
</style>
